import React from "react";
import { FaMapMarkerAlt, FaEnvelope, FaPhoneAlt } from "react-icons/fa";
import contactBanner from "../assets/contact/contact_banner.png";
import officeFront from "../assets/contact/foto_kantor_depan.jpg";

const ContactALL = () => {
  const cards = [
    {
      icon: <FaMapMarkerAlt size={28} color="#2563eb" />,
      title: "Address",
      content: (
        <>
          Jl. Science Boulevard Blok A2 No.8 <br />
          Kawasan Industri Jababeka Tahap 5 <br />
          Cikarang Timur, Bekasi 17530
        </>
      ),
    },
    {
      icon: <FaEnvelope size={28} color="#16a34a" />,
      title: "Email",
      content: (
        <>
          Mulyadi@otokresindo.com <br />
          muklisin@otokresindo.com <br />
          marketing@otokresindo.com
        </>
      ),
    },
    {
      icon: <FaPhoneAlt size={28} color="#f59e0b" />,
      title: "Contact Person",
      content: (
        <>
          (+62) 812-9610-043 <br />
          Bpk. Mulyadi - Direktur <br />
          (+62) 812-1489-5985 <br />
          Bpk. Muklisin - Marketing
        </>
      ),
    },
  ];

  return (
    <section
      id="contact"
      style={{
        paddingTop: "100px",
        backgroundColor: "white",
      }}
    >
      {/* === Banner Contact === */}
      <div
        className="contact-banner"
        style={{
          position: "relative",
          width: "100%",
          height: "300px",
          backgroundImage: `url(${contactBanner})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "contain",
          backgroundPosition: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "white",
          textAlign: "center",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.4)",
          }}
        ></div>

        <h1
          style={{
            position: "relative",
            fontSize: "2.5rem",
            fontWeight: "bold",
            zIndex: 1,
            textShadow: "2px 2px 5px rgba(0,0,0,0.5)",
          }}
        >
          Contact Us
        </h1>
      </div>

      {/* === Konten Kontak === */}
      <div
        style={{
          padding: "4rem 2rem 2rem 2rem",
          background: "linear-gradient(135deg, #bbf7d0, #fef08a)",
        }}
      >
        <h2
          style={{
            textAlign: "center",
            fontSize: "2rem",
            fontWeight: "bold",
            color: "#111827",
            marginBottom: "2.5rem",
          }}
        >
          Get in Touch
        </h2>

        {/* Grid Cards */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
            gap: "2rem",
            maxWidth: "1000px",
            margin: "0 auto",
          }}
        >
          {cards.map((card, i) => (
            <div
              key={i}
              style={{
                background: "white",
                padding: "2rem 1.5rem",
                borderRadius: "12px",
                boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                color: "#111",
                transition: "all 0.3s ease",
                cursor: "pointer",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-6px)";
                e.currentTarget.style.boxShadow =
                  "0 10px 20px rgba(0,0,0,0.15)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 4px 10px rgba(0,0,0,0.1)";
              }}
            >
              {card.icon}
              <h3
                style={{
                  marginTop: "1rem",
                  fontSize: "1.2rem",
                  fontWeight: "bold",
                  color: "#111827",
                }}
              >
                {card.title}
              </h3>
              <p
                style={{
                  marginTop: "0.5rem",
                  lineHeight: "1.6",
                  fontSize: "0.95rem",
                  color: "#374151",
                }}
              >
                {card.content}
              </p>
            </div>
          ))}
        </div>

        {/* === Office Photo + Google Maps === */}
        <div
          style={{
            marginTop: "4rem",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              width: "100%",
              maxWidth: "1000px",
              borderRadius: "12px",
              overflow: "hidden",
              background: "white",
              padding: "1rem",
              boxShadow: "0 4px 15px rgba(0,0,0,0.15)",
            }}
          >
            {/* Foto Kantor */}
            <div style={{ marginBottom: "1rem" }}>
              <img
                src={officeFront}
                alt="Tampak Depan Kantor OKI"
                style={{
                  width: "100%",
                  borderRadius: "8px",
                }}
              />
              <p
                style={{
                  textAlign: "center",
                  marginTop: "0.5rem",
                  fontSize: "0.9rem",
                  fontStyle: "italic",
                  color: "#444",
                }}
              >
                Foto Tampak Depan Kantor Otokresindo
              </p>
            </div>

            {/* MAP DESCRIPTION */}
            <p
              style={{
                textAlign: "center",
                margin: "1rem 0",
                fontSize: "1rem",
                fontWeight: "600",
                color: "#222",
              }}
            >
              Lokasi Kantor Otokresindo pada Google Maps
            </p>

            {/* Google Maps */}
            <iframe
              title="Otokresindo Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3965.6316484819617!2d107.1758491!3d-6.312025799999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xa1dfe644a7d0a023%3A0x208e3474be3caed8!2sPT.%20OTO%20KREASI%20INDO!5e0!3m2!1sid!2sid!4v1763260051081!5m2!1sid!2sid"
              style={{
                border: 0,
                width: "100%",
                height: "400px",
                borderRadius: "8px",
                display: "block",
              }}
              allowFullScreen
              loading="lazy"
            ></iframe>
          </div>
        </div>
      </div>

      {/* === Responsive Adjustments === */}
      <style>{`
        @media (max-width: 1024px) {
          #contact { padding-top: 95px !important; }
          .contact-banner { height: 250px !important; }
        }

        @media (max-width: 768px) {
          #contact { padding-top: 90px !important; }
          .contact-banner { height: 220px !important; }
          iframe { height: 300px !important; }
        }

        @media (max-width: 480px) {
          #contact { padding-top: 85px !important; }
          .contact-banner { height: 200px !important; }
          iframe { height: 250px !important; }
        }
      `}</style>
    </section>
  );
};

export default ContactALL;
